<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import common from "./common/common";
import axios from 'axios'
export default {
  name: "App",
  components: {},

  created() {
    // let selectId = localStorage.getItem('selectId')
    // let uinfoLocal = localStorage.getItem('uInfo')
    // let showChildrenSide = localStorage.getItem('showChildrenSide')

    // if(!this.$store.state.selectId && selectId){
    //   let id = common.decryptData(selectId)
    //   let res = id.slice(6,id.length-2)
    //   this.$store.commit('setSelectId',res)

    //   console.log('uinfoLocal',uinfoLocal)
    //   let uinfo = common.decryptData(JSON.parse(uinfoLocal) )
    //   this.$store.commit('set_uInfo',uinfo)

    //   let res1 = showChildrenSide=='false'?false:true
    //   this.$store.commit('setShowChildrenSide',res1)

    // }
   


    if (sessionStorage.getItem("store")) {
      this.$store.replaceState(
        Object.assign(
          {},
          this.$store.state,
          JSON.parse(sessionStorage.getItem("store"))
        )
      );
    }

    window.addEventListener("beforeunload", () => {
      // console.log(111111111)
      sessionStorage.setItem("store", JSON.stringify(this.$store.state));
      if (this.$store.state.local)
        localStorage.setItem("local", this.$store.state.local);
      if (
        this.$store.state.langSet === false ||
        this.$store.state.langSet === true
      )
        localStorage.setItem("langSet", this.$store.state.langSet);
    });

    if (!this.$store.state.uInfo && localStorage.getItem("uInfo")) {
      //  console.log(2222222)
      this.$store.commit("set_uInfo", common.decryptDataUinfo());
    }

    if (this.$store.state.uInfo && this.$store.state.uInfo.roleType == 1) {
      //总账号
      if (!this.$store.state.selectId && localStorage.getItem("selectId")) {
        //  console.log(333333)
        let selectId = common.decryptDataUinfo('myselectId','selectId').slice(6,-2)
        this.$store.commit("setSelectId", selectId);
      }

      if (this.$store.state.selectId == this.$store.state.uInfo.id || (!this.$store.state.selectId && !localStorage.getItem('selectId'))) {
        // console.log(4444444)
        
        this.$store.commit("setSelectId", this.$store.state.uInfo.id);
        this.$store.commit("setShowChildrenSide", true);
        // this.$router.push({path:'/'})
        axios.defaults.headers.common['Authorization'] = this.$store.state.uInfo.jwt;
      } else {
        //  console.log(555555)
        this.$store.commit("setShowChildrenSide", false);
      }
      
    } else if (
      this.$store.state.uInfo &&
      this.$store.state.uInfo.roleType == 2
    ) {
      // console.log("6666666");
      this.$store.commit("setShowChildrenSide", false);
      this.$store.commit("setSelectId", this.$store.state.uInfo.id);
      axios.defaults.headers.common['Authorization'] = this.$store.state.uInfo.jwt;
    }
    this.$store.commit("setTokenInvalidFlag", false);

    // console.log("this.$store", this.$store.state);
  },
  watch: {},
  methods: {},
  mounted() {},
};
</script>
<style lang="less">
@import "./resourse/iconfont/iconfont.css";
.view {
  z-index: 4 !important;
}
.ivu-table-wrapper {
  overflow: unset !important;
}
.ivu-table {
  background-color: #ffffff00 !important;
}
.ivu-table:after {
  background-color: #ffffff00 !important;
}
.ivu-table:before {
  background-color: #ffffff00 !important;
}
.ivu-select-dropdown{
  max-width: 300px;
}

.ivu-table-cell {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  word-break: break-all;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
}
.ivu-page {
  display: flex;
  justify-content: flex-end;
  margin-right: 20px;
}
.pagesimg {
  margin: 10px auto;
  text-align: center;
}
.ivu-table th,
.ivu-table td {
  text-align: center !important;
}
.ivu-table-overflowY {
    overflow-y: auto;
}
.ivu-table-overflowX {
    overflow-y: auto;
}


/* 加载框 */
.gglist {
  position: relative;
  /* height: 100px; */
}

.marginCon {
  margin: 42px 40px 8px
}
.demo-spin-icon-load {
  animation: ani-demo-spin 1s linear infinite;
}
@keyframes ani-demo-spin {
  from {
    transform: rotate(0deg);
  }
  50% {
    transform: rotate(180deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.demo-spin-col {
  height: 100px;
  position: relative;
  border: 1px solid #eee;
}
.top {
  margin: 30px auto;
  margin-bottom: 0;
}

.pages {
  margin: 30px auto;
}
.ivu-modal {
  width: 416px;
}
.table-content {
  min-width: 800px;
  overflow-x: scroll;
  padding-top: 30px;
}
.ivu-card-body {
  // overflow-x: auto;
  // height: calc(100vh - 140px);
  min-height: calc(100vh - 150px);
}
.search-div {
  margin: 5px 0px 10px 0px;
  .input-div {
    width: 200px;
    margin: 5px 5px;
    display: inline-block;
  }
}


@media print {
  .Noprn {
    display: none !important;
  }
}
.ivu-table-cell {
  max-height: 63px;
}
.kong-td {
  text-align: center;
  font-size: 13px;
  padding: 5px 0px;
  font-weight: 600;
  box-sizing: border-box;
}
.ivu-message {
  z-index: 10045 !important;
}
li {
  list-style: none;
}
.flex {
  display: flex;
}
.flexC {
  display: flex;
  align-content: center;
}
.flexCC {
  display: flex;
  align-content: center;
  justify-content: center;
}
.flexBC {
  display: flex;
  align-content: center;
  justify-content: space-between;
}
.flexAC {
  display: flex;
  align-content: center;
  justify-content: space-around;
}
.flexD {
  display: flex;
  flex-direction: column;
}
/*单行溢出*/
.one-txt-cut {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

/*多行溢出*/
.txt-cut2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}

::-webkit-scrollbar {
  /*定义滚动条宽高及背景，宽高分别对应横竖滚动条的尺寸*/
  width: 10px;
  height: 10px;
  background-color: #f5f5f5;
}

::-webkit-scrollbar-thumb {
  /*定义滑块 内阴影+圆角*/
  background: hsla(0, 0%, 100%, 0.1);
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.25);
  box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.25);
}

::-webkit-scrollbar-track {
  /*定义滚动条轨道 内阴影+圆角*/
  background: rgba(255, 255, 255, 0.15);
  border-radius: 6px;
  -webkit-box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.25);
   box-shadow: inset 0 0 10px rgba(0, 0, 0, 0.25);
}
</style>

